import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const SecuringiotDevices = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <section
        style={{
          backgroundImage: `url('../images/securing-iot-device.jpg')`,
          backgroundSize: "100% 60vh",
        }}
        className="hero--container relative flex flex-col justify-center w-full h-[60vh] bg-no-repeat bg-fixed md:bg-origin-border pt-[65px]"
      >
        <p className="text-white p-1.5 rounded-md text-xs font-bold text-center mb-10 bg-blue-500 mx-auto">
          IoT, Security
        </p>
        <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
          Best Practices for Securing IoT Devices
        </h1>

        <div className="flex justify-center items-center gap-4 mt-10">
          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faClock} className="w-4" />
            <p className="blog-publish-date">27/01/2025</p>
          </div>

          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faComment} className="w-4" />
            <p className="blog-publish-date">3 Comments</p>
          </div>

          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faBookmark} />
            <p className="blog-publish-date">1200 Views</p>
          </div>
        </div>
      </section>

      <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
        <div className="mx-auto max-w-screen-md">
          <p className="pb-4 text-justify leading-7">
            The Internet of Things (IoT) has transformed the way we interact with technology, enabling devices to communicate and share data seamlessly. However, as IoT adoption grows, so does the risk of cyber threats. Securing IoT devices is paramount to protect sensitive information and ensure a safe digital environment.
          </p>

          <img src="../images/securing-iot-device.jpg" alt="" className="mx-auto mt-3 mb-6 w-full" />

          <h2 className="font-bold text-lg pb-2">1. Use Strong Passwords and Authentication</h2>
          <p className="pb-4 text-justify leading-7">
            Weak passwords are a common entry point for attackers. Always use strong, unique passwords for IoT devices. Enable multi-factor authentication (MFA) wherever possible to add an extra layer of security.
          </p>

          <h2 className="font-bold text-lg pb-2">2. Keep Firmware and Software Updated</h2>
          <p className="pb-4 text-justify leading-7">
            Manufacturers frequently release updates to fix vulnerabilities. Ensure your IoT devices are updated with the latest firmware and software patches to reduce exposure to known exploits.
          </p>

          <h2 className="font-bold text-lg pb-2">3. Secure Your Network</h2>
          <p className="pb-4 text-justify leading-7">
            Use a secure Wi-Fi network with strong encryption protocols like WPA3. Segment IoT devices on a separate network to minimize the risk of spreading malware if one device is compromised.
          </p>

          <h2 className="font-bold text-lg pb-2">4. Disable Unnecessary Features</h2>
          <p className="pb-4 text-justify leading-7">
            Many IoT devices come with features that may not be essential for your use. Disable features like remote access and Universal Plug and Play (UPnP) if they are not required, as they can expose devices to external threats.
          </p>

          <h2 className="font-bold text-lg pb-2">5. Monitor Device Behavior</h2>
          <p className="pb-4 text-justify leading-7">
            Keep an eye on your devices for unusual activity. Sudden spikes in data usage or unexplained behavior could indicate a security breach. Use tools to monitor and log device activity.
          </p>

          <h2 className="font-bold text-lg pb-2">6. Choose Devices with Built-In Security</h2>
          <p className="pb-4 text-justify leading-7">
            Invest in devices from reputable manufacturers that prioritize security. Look for certifications or standards compliance that indicate robust security practices.
          </p>

          <h2 className="font-bold text-lg pb-2">7. Encrypt Data</h2>
          <p className="pb-4 text-justify leading-7">
            Ensure that data transmitted between devices is encrypted. This prevents attackers from intercepting and reading sensitive information during communication.
          </p>

          <h2 className="font-bold text-lg pb-2">8. Educate Yourself and Your Team</h2>
          <p className="pb-4 text-justify leading-7">
            Knowledge is one of the best defenses. Understand the risks associated with IoT devices and educate your family or team members about safe usage practices.
          </p>

          <p className="pb-4 text-justify leading-7">
            By adopting these best practices, you can significantly reduce the security risks associated with IoT devices. As technology continues to evolve, staying vigilant and proactive is key to protecting your digital ecosystem.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <div className="max-w-screen-md mx-auto rounded-md flex justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">IoT</p>
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Security</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center bg-[#42599E] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} /> share
              </a>
            </div>
            <div className="flex items-center bg-[#55ACEE] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} /> tweet
              </a>
            </div>
            <div className="flex items-center bg-[#34AF23] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} /> whatsapp
              </a>
            </div>
            <div className="flex items-center bg-[#0798CF] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} /> linkedin
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SecuringiotDevices;